import { combineReducers } from 'redux';

import servicesReducer from './services/servicesReducer';
import { reducer as related } from './relatedModule';

export default combineReducers({
	related,
	services: servicesReducer,
});
